<template>
    <div class="floating-nav">
        <div class="floating-nav__item">
            <img class="item-icon" src="@/static/navImage/linkUs.png" alt="联系我们" />
            <span class="item-text">联系我们</span>
            <div class="preview-image">
                <img src="@/static/navImage/linkUs.png" alt="联系我们二维码" />
                <p class="preview-text">联系我们</p>
            </div>
        </div>

        <div class="floating-nav__item">
            <img class="item-icon" src="@/static/navImage/wechat.png" alt="商务微信" />
            <span class="item-text">商务微信</span>
            <div class="preview-image">
                <img src="@/static/navImage/wechat.png" alt="商务微信二维码" />
                <p class="preview-text">商务微信</p>
            </div>
        </div>

        <div class="floating-nav__item" @click="handleApply">
            <img class="item-icon" src="@/static/navImage/honest.png" alt="合作申请" />
            <span class="item-text">合作申请</span>
            <!-- <div class="preview-image">
                <img src="@/static/navImage/honest.png" alt="合作申请二维码" />
                <p class="preview-text">合作申请</p>
            </div> -->
        </div>

        <div class="floating-nav__item floating-nav__item--top" @click="scrollToTop" v-show="showBackToTop">
            <img class="item-icon" src="@/static/navImage/backTotop.png" alt="回到顶部" />
            <span class="item-text">回到顶部</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FloatingNav',

    data() {
        return {
            showBackToTop: false
        }
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },

    methods: {
        // 处理滚动事件
        handleScroll() {
            this.showBackToTop = window.pageYOffset > 300
        },

        // 回到顶部
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },

        // 合作申请
        handleApply() {
            this.$router.push('/apply')
        }
    }
}
</script>

<style lang="scss" scoped>
.floating-nav {
    position: fixed;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 12px;

    @media (max-width: 768px) {
        right: 15px;
        gap: 8px;
    }

    &__item {
        width: 80px;
        height: 80px;
        background: linear-gradient(135deg, #f5a623 0%, #e67e22 100%);
        border-radius: 12px;
        box-shadow: 0 2px 12px rgba(245, 166, 35, 0.4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        overflow: visible;
        padding: 8px;

        @media (max-width: 768px) {
            width: 60px;
            height: 60px;
            padding: 6px;
        }

        .item-icon {
            width: 32px;
            height: 32px;
            object-fit: contain;
            transition: transform 0.3s ease;
            filter: brightness(0) invert(1);

            @media (max-width: 768px) {
                width: 24px;
                height: 24px;
            }
        }

        .item-text {
            font-size: 11px;
            color: #fff;
            font-weight: 500;
            text-align: center;
            line-height: 1.2;
            transition: transform 0.3s ease;
            white-space: nowrap;

            @media (max-width: 768px) {
                font-size: 9px;
            }
        }

        .preview-image {
            position: absolute;
            right: 100%;
            margin-right: 16px;
            background-color: #fff;
            padding: 16px;
            border-radius: 8px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.3s ease;
            min-width: 200px;

            img {
                width: 200px;
                height: 200px;
                object-fit: cover;
                border-radius: 4px;
                background-color: #f5f5f5;
                display: block;
            }

            .preview-text {
                margin: 12px 0 0 0;
                text-align: center;
                font-size: 14px;
                color: #333;
                font-weight: 500;
            }

            &::after {
                content: '';
                position: absolute;
                right: -8px;
                top: 50%;
                transform: translateY(-50%);
                width: 0;
                height: 0;
                border-left: 8px solid #fff;
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
            }
        }

        &:hover {
            background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
            transform: translateX(-5px) scale(1.05);
            box-shadow: 0 4px 20px rgba(245, 166, 35, 0.6);

            .item-icon {
                transform: scale(1.15);
            }

            .item-text {
                transform: scale(1.05);
            }

            .preview-image {
                opacity: 1;
            }
        }
    }
}
</style>
